import React from 'react'
import { connect } from 'react-redux'
import { withRouter, NavLink } from 'react-router-dom'

import config from '../config.js'
import { Link, H1, Badge, IconButton, Button } from '../components/index.js'
import { toggleNavMenu, closeNavMenu } from '../navigation/actions.js'
import { selectIsMenuOpen } from '../navigation/reducer.js'
import Avatar, { AvatarItem } from '@atlaskit/avatar'
import { selectJiraUser, selectADUserInfo, hasAuthCheckFinished, isLoggedIn, isAdmin, selectEmail } from '../auth/reducer'
import { logoutUser, loginUser } from '../auth/actions.js'

const navStyle = 'nav pt4-sm pb4-sm prl6-sm u-no-ws'
const nikeTechSlack = `https://nikedigital.slack.com/archives/C0JSX3QSZ`
const nikeDigitalSlack = `https://nikedigital.slack.com/messages/${config.slack.channelId}`

let NavLinkItem = ({ to, label }) => (
  <li className='text-color-secondary'>
    <NavLink to={to} activeClassName='text-color-accent' exact>
      {label}
    </NavLink>
  </li>
)

const SlideMenuContainer = (
  { isOpen, 
    closeNavMenu, 
    isLoggedIn, 
    isReady, 
    jiraUser, 
    adUser, 
    isAdmin, 
    title, 
    description, 
    toggleNavMenu, 
    notifications, 
    children, 
    navLinks,
    env,
    email,
    ...props }) => {
  return (
    <div className={`menu-container ${isOpen ? 'show-menu' : ''}`}>
      <div className='menu-aside border-right bg-white' onClick={closeNavMenu}>
        <Link to='/' className='pt1-sm prl6-sm pb1-sm u-sm-b border-bottom'>
          <H1 className={'u-uppercase ncss-brand'} useBareClass>
            <i className='g72-swoosh nav-brand fs22-sm menu-logo' />
            <span className='fs30-sm ncss-brand u-italic'>{title}</span>
          </H1>
        </Link>
        {renderProfileNav({jiraUser, adUser, isLoggedIn, isReady, email})}
        <nav className={navStyle}>
          <ul>
            {navLinks.map(({to, label}) => <NavLinkItem key={to} to={to} label={<span className='fs18-sm pt2-sm pb2-sm'>{label}</span>} />)}
            {isAdmin ? <NavLinkItem key='/Admin' to='/Admin' label={<span className='fs18-sm pt2-sm pb2-sm'>Admin Tools</span>} /> : null}
          </ul>          
        </nav>
        
        <div className='footer pb4-md'>
          <div className='footer-spacer border-bottom mb2-sm' />
          <nav className={navStyle}>
            <p className='fs14-sm lh14-sm u-align-center pb2-sm' style={{whiteSpace: 'normal'}}>Have a bug report or feature request? Find us in Slack.</p>
            <a href={nikeTechSlack} target="_blank" className='u-sm-b'>
              <Button extraClassName='mb4-md u-full-width' small color='border-grey'>
                #inf-buildtools
              </Button>
            </a>
          </nav>
          <span className='text-color-secondary prl2-sm fs12-sm lh12-sm'>{description}</span>
          <span className='text-color-secondary prl2-sm fs12-sm lh12-sm'>{'© 2020-2026 Nike, Inc. All Rights Reserved'}</span>
          <span className='text-color-secondary prl2-sm fs12-sm lh12-sm'>Environment: {env}</span>
        </div>
      </div>
      <div className='viewport'>
        <button type='button' className='menu-btn ncss-btn fs16-sm' onClick={toggleNavMenu}>
          <Badge count={notifications} />
          <i className='g72-menu' />
        </button>
        {children}
      </div>
      <div className='menu-lightbox' onClick={closeNavMenu} />
    </div>
  )
}

const renderProfileNav = ({ jiraUser, adUser, isLoggedIn, isReady, loginUser, logoutUser, email}) => (
  isLoggedIn && isReady
    ? <nav className={navStyle}>
      <div className='profile-nav'>
        <Link to='/user'>        
            <AvatarItem
              avatar={<Avatar src={jiraUser && jiraUser.avatarUrls ? jiraUser.avatarUrls['48x48'] : null} size='large' />}
              key={jiraUser ? jiraUser.emailAddress : adUser ? adUser.email : email}
              primaryText={jiraUser ? jiraUser.displayName: adUser ? adUser.firstName + ' ' + adUser.lastName : null}
              secondaryText={jiraUser ? jiraUser.emailAddress: adUser ? adUser.email : email}
              enableTextTruncate={true}
            />
          </Link>
        <div className='profile-nav-item fs22-sm'>
          {/* Logout button commented out as currently it returns error that loutoutUser is not a function.
          is a bonus option, not needed for MVP
          TODO: fix later */}
          {/* <IconButton onClick={() => logoutUser()} icon='sign-out' title='logout' color='grey' /> */}
        </div>
      </div>      
    </nav>
    : null
)

export default withRouter(connect((state, ownProps) => ({
  isReady: hasAuthCheckFinished(state),
  isOpen: selectIsMenuOpen(state),
  isLoggedIn: isLoggedIn(state),
  navLinks: ownProps.navLinks || [],
  jiraUser: selectJiraUser(state),
  adUser:selectADUserInfo(state),
  isAdmin: isAdmin(state),
  email: selectEmail(state),
}), { toggleNavMenu, closeNavMenu, loginUser, logoutUser })(SlideMenuContainer))



// WEBPACK FOOTER //
// ./client/src/navigation/SlideMenuContainer.js